<script setup lang="ts">
  import { IBranch, ISocialLink } from '@/interfaces/IBranch';
  import { useRestaurantStore } from '@/stores/restaurant.store';
  import { computed, ref } from 'vue';

  const props = defineProps<{
    editingBranch: IBranch;
  }>();

  const restaurantStore = useRestaurantStore();

  const links = computed({
    get: () => props.editingBranch.links ?? [],
    set: (value: ISocialLink[]) => {
      props.editingBranch.links = value;
      console.log(props.editingBranch.links);
    },
  });

  function addLink() {
    links.value = [...links.value, { title: '', url: '' }];
  }

  const canUseLinks = computed(() => restaurantStore.effectiveTier > 0);
</script>

<template>
  <div class="social-links">
    <template v-if="!canUseLinks">
      <VIcon>mdi-information</VIcon>
      Actualice a un plan pago para agregar links, redes sociales y activar mas
      opciones de personalización.
    </template>
    <template v-else>
      <div v-for="(link, index) in links" :key="index" class="social-link">
        <VIcon>mdi-circle-small</VIcon>
        <div class="fields">
          <VTextField
            v-model="link.title"
            class="title-input"
            label="Título del link"
            placeholder="Ejemplo: Facebook"
            :rules="$rule('required|max48')"
            outlined
            dense
            hide-details
          />
          <VTextField
            v-model="link.url"
            class="url-input"
            label="Dirección del link"
            placeholder="Ejemplo: https://facebook.com/..."
            :rules="$rule('required|url')"
            outlined
            dense
            hide-details
          />
        </div>
        <VBtn
          class="remove-link"
          color="error"
          @click="links.splice(index, 1)"
          elevation="0"
          rounded
          icon
        >
          <VIcon>mdi-delete</VIcon>
        </VBtn>
      </div>
      <VBtn
        class="add-link"
        color="primary"
        @click="addLink"
        elevation="0"
        rounded
      >
        <VIcon>mdi-plus</VIcon>
        Agregar link
      </VBtn>
    </template>
  </div>
</template>

<style scoped lang="scss">
  .social-links {
    @apply tw-py-4 tw-space-y-3;

    .social-link {
      @apply tw-flex tw-items-center tw-space-x-2;

      .fields {
        @apply tw-flex-1 tw-flex tw-flex-col tw-space-y-2 sm:tw-flex-row sm:tw-items-center sm:tw-space-x-2 sm:tw-space-y-0;
      }
    }
  }
</style>
